export const sortJson = (json, objectPath) => {

  try {
    return json.sort((objectA, objectB) => objectA[objectPath].localeCompare(objectB[objectPath]));
  } catch (TypeError) {
    console.log(TypeError);
    return [];
  }
};